import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

import { organizationType } from 'const/nuclias/organization';
import InputWithIcon from '../InputWithIcon';

const DropdownItem = props => {
  const { itemIcon, item, onClick } = props;
  const { t } = useTranslation();
  return (
    <li
      className={`${item.isActive ? 'active' : ''}`}
      onClick={() => !!onClick && onClick(item)}
    >
      <i className={`icon ${itemIcon}`}></i>
      {t(item.title)}
    </li>
  );
};

const SiteTagOrSiteDropdownList = props => {
  const {
    id,
    tmpAccessLevel,
    itemList = [],
    disabled,
    onChangeSelectedItem,
  } = props;
  const { t } = useTranslation();

  const [inputSearchValue, setInputSearchValue] = useState('');
  const [selectedItemList, setSelectedItemList] = useState(cloneDeep(itemList));
  const siteTagOrSiteIndex = selectedItemList.findIndex(item => !!item.isActive);

  let accessLevelText = null;
  let itemIcon = null;
  switch (tmpAccessLevel) {
    case organizationType.tag:
      accessLevelText = 'a3f530195f'; // Managed Site tag
      itemIcon = 'icon-tag';
      break;
    case organizationType.site:
      accessLevelText = '199e0bdbbb'; // Managed Site
      itemIcon = 'icon-site';
      break;
    default:
      accessLevelText = '';
      itemIcon = '';
      break;
  }

  const onChangeSearch = event => {
    setInputSearchValue(event.target.value);

    const filteredTmpItemList = cloneDeep(itemList).filter(item => !!item ? item.title.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1 : true);
    filteredTmpItemList.forEach((item, index) => item.isActive = index === 0);
    setSelectedItemList(filteredTmpItemList);

    const selectedItem = filteredTmpItemList.filter(item => item.isActive)[0] || null;
    onChangeSelectedItem && onChangeSelectedItem(selectedItem);
  }

  const checkSelectedItem = event => {
    const newItemList = selectedItemList.map((item, index) => {
      if (event?.id === item.id) {
        return { ...item, isActive: true };
      } else {
        return { ...item, isActive: false };
      }
    });
    setSelectedItemList(newItemList);
  };

  useEffect(() => {
    setSelectedItemList(cloneDeep(itemList));
  }, [itemList])

  return (
    <div className="dropdown-with-item-container mb-2">
      {/* Managed Site tag / Site */}
      <div className={'access-privilege-text'}>{t(accessLevelText)}</div>
      <div className="dropdown">
        <button
          className={`btn btn-dropdown dropdown-toggle`}
          type="button"
          id={id}
          data-bs-toggle="dropdown"
          data-bs-display="static"
          disabled={disabled}
          aria-expanded="false"
        >
          <span>
            <i className={`icon ${itemIcon}`}></i>
            {selectedItemList[siteTagOrSiteIndex]?.title}
          </span>
        </button>
        <ul className="dropdown-menu" aria-labelledby={id}>
          <InputWithIcon
            type="search"
            placeholder="Search"
            iconPosition="left"
            iconClassName="icon-search"
            value={inputSearchValue}
            onChange={event => onChangeSearch(event)}
          />
          {selectedItemList.map((item, index) => (
            <DropdownItem
              itemIcon={itemIcon}
              item={item}
              key={item.title + '-' + index}
              onClick={item => {
                checkSelectedItem(item);
                onChangeSelectedItem && onChangeSelectedItem(item);
              }}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SiteTagOrSiteDropdownList;
